import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import { useFormik } from "formik";
import { STATUS_PROCESS } from "libs/configs/constant";
import { SMART_NAME } from "libs/constant/smartForm";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  getMinRequired,
  transformDocumentRequired,
  transformDocumentTopic,
} from "libs/utils/uploadDocument";
import { get } from "lodash-es";
import mime from "mime";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSmartCompany,
  uploadSmartCompanyDoc,
} from "redux/modules/smartCompanySlice";
import {
  addSmartfromExtension,
  selectDocumentRequired,
  selectReqdoclogList,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function useUploadDocumentForm({
  isExtension,
  isCompanyUploadDoc,
  canEdit,
  isBypassAccept,
}) {
  const dispatch = useDispatch();
  const { showLoading } = useModalLoading();

  const smartCompanyState = useSelector(selectSmartCompany);
  const { data: documentRequired } = useSelector(selectDocumentRequired);
  const { list: reqdoclogList } = useSelector(selectReqdoclogList);
  const { smartserviceId, smartType, smartService } = useSmartService();
  const {
    draftId,
    addSmartForm,
    smartform,
    condition,
    fileDocument: fileDocumentSmartForm,
  } = useSmartForm();
  const { personalId: personalID } = usePersonalDetail();

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );
  const smartCompanyData = get(smartCompanyState, "data", {});
  const fileDocumentCompany = get(smartCompanyData, "documentRequireds", []);
  const fileDocument = isCompanyUploadDoc
    ? fileDocumentCompany
    : fileDocumentSmartForm;
  const conditionType = get(smartformDetail, "ConditionType.value", "");
  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceReferId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");
  const statausID = get(smartform, "statausID", "");
  const smartTypeExtension = SMART_NAME[smartserviceName];

  const isDepartmentRequestDoc = statausID === STATUS_PROCESS.RequestAddDoc;
  const isPending = statausID === "P";
  const isDisabledRemoveButton = isDepartmentRequestDoc || isPending;

  const getRemarkByConfigDocumentRequired = (id) =>
    (isDisabledRemoveButton ? reqdoclogList : [])
      .reduce((p, c) => {
        const listFilter = c.detail.filter(
          (v) => v.configDocumentRequiredID === id
        );
        if (listFilter.length > 0) {
          return [
            ...p,
            ...listFilter.reduce((pi, ci) => [...pi, ci.remark], []),
          ];
        }

        return p;
      }, [])
      .join(", ");

  const fieldRequired = "isRequired";

  const rawDocuments = transformDocumentRequired(documentRequired);
  const allTocpic = transformDocumentTopic(rawDocuments);
  const documents = rawDocuments.map((v) => ({
    ...v,
    topic: v.topic.map((t) => ({
      ...t,
      remark: getRemarkByConfigDocumentRequired(t.configDocumentRequiredID),
    })),
  }));
  const validationSchema = yup.object({
    ...(canEdit
      ? allTocpic.reduce(
          (p, c, i) => ({
            ...p,
            [c.documentID]: yup
              .array()
              // .min(
              //   getMinRequired(c[fieldRequired]),
              //   `(${c.docIndex}) Document is required.`
              // )
              .test(
                "lengthFilter",
                `(${c.docIndex}) Document is required.`,
                (value) => {
                  if (getMinRequired(c[fieldRequired]) === 0) return true;
                  return value && value.filter((v) => v.status).length;
                }
              ),
          }),
          {}
        )
      : {}),
    accep1: canEdit
      ? yup.bool().oneOf([true], `Your never accept agreement`)
      : null,
  });
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      ...allTocpic.reduce(
        (p, c) => ({
          ...p,
          [c.documentID]: fileDocument
            .filter(
              (doc) =>
                doc.configDocumentRequiredID === c.configDocumentRequiredID
            )
            .map((doc) => ({
              ...doc,
              status: true,
              file: new File(
                [new Blob()],
                `${doc.fileName || doc.filename}${doc.ext}`,
                {
                  type: mime.getType(doc.ext),
                }
              ),
            })),
        }),
        {}
      ),
      accep1: isBypassAccept || false,
    },
    onSubmit: async (values) => {
      // showLoading();
      const backlist = ["accep1"];
      const whitelistKey = Object.keys(values).filter(
        (v) => !backlist.includes(v)
      );
      const whitelistValue = whitelistKey
        .map((key) => values[key])
        .filter((v) => v.length > 0)
        .reduce((p, c) => [...p, ...c], []);

      if (isExtension) {
        const prepareData = {
          ...smartform,
          detail: whitelistValue.map((value) => ({
            partfromId: null,
            configsmartId: null,
            linkTable: "",
            value: null,
            configConditionVisaId: null,
            // ---
            smartId: value.smartId || null,
            configDocumentRequiredID: value.configDocumentRequiredID,
            ocRtext: value.ocRtext || "",
            fileID: value.fileID || "",
            status: value.status !== undefined ? value.status : true,
          })),
        };
        await dispatch(addSmartfromExtension({ data: prepareData }));
      } else {
        const prepareData = {
          ...smartform,
          // draftId: draftId || null,
          // smartserviceId,
          // personalId: personalID,
          // visaRequestID: smartform.visaRequestID || null,
          detail: whitelistValue.map((value) => ({
            partfromId: null,
            configsmartId: null,
            linkTable: "",
            value: null,
            configConditionVisaId: null,
            // ---
            smartId: value.smartId || null,
            configDocumentRequiredID: value.configDocumentRequiredID,
            ocRtext: value.ocRtext || "",
            fileID: value.fileID || "",
            status: value.status !== undefined ? value.status : true,
          })),
        };

        if (isCompanyUploadDoc) {
          dispatch(
            uploadSmartCompanyDoc({
              smartCompanyID: get(smartCompanyData, "smartCompanyID", null),
              documentReq: whitelistValue.map((value) => ({
                smartCompanyDoc: value.smartCompanyDoc || null,
                configDocumentRequiredID: value.configDocumentRequiredID,
                fileID: value.fileID || "",
                status: value.status !== undefined ? value.status : true,
              })),
            })
          );
        } else {
          await addSmartForm({
            data: prepareData,
          });
        }
      }
    },
  });

  console.log("errors ", formik.errors);

  return {
    personalID,
    documents,
    formik,
    condition,
    draftId,
    isDisabledRemoveButton,
    isDepartmentRequestDoc,
    reqdoclogList,
  };
}
